import { render, staticRenderFns } from "./GameMessage.vue?vue&type=template&id=5f4e6729&scoped=true&"
import script from "./GameMessage.vue?vue&type=script&lang=ts&"
export * from "./GameMessage.vue?vue&type=script&lang=ts&"
import style0 from "./GameMessage.vue?vue&type=style&index=0&id=5f4e6729&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e6729",
  null
  
)

export default component.exports